/**
 * Encart d'inscription d'origine (paramètre cta_source des liens internes vers
 * /inscription/, cadrage de la frontière §4 et §5). Miroir de App\Service\Analytics\CtaSource :
 * identifiant court en minuscules (a-z, 0-9, « _ », « - », 60 caractères), toute autre valeur
 * refusée. Gardé pour la visite (sessionStorage), envoyé avec la demande de lien magique et
 * le départ Google ; le serveur le garde ensuite avec le jeton jusqu'au compte.
 * Pas d'utm_* sur un lien interne : il écraserait l'origine de la visite (Google).
 */
const STORAGE_KEY = "km_cta_source";

export function sanitizeCtaSource(raw: string | null | undefined): string | null {
  if (typeof raw !== "string") return null;
  const value = raw.trim().toLowerCase();
  return /^[a-z0-9_-]{1,60}$/.test(value) ? value : null;
}

function stored(): string | null {
  try {
    return sanitizeCtaSource(window.sessionStorage.getItem(STORAGE_KEY));
  } catch {
    return null;
  }
}

/**
 * Lit ?cta_source= de l'adresse et le garde pour la visite (une valeur invalide est ignorée).
 * $fallback : encart déduit de la page quand l'adresse n'en porte pas (mur d'un outil).
 */
export function rememberCtaSource(search: string = typeof window !== "undefined" ? window.location.search : "", fallback: string | null = null): void {
  const value = sanitizeCtaSource(new URLSearchParams(search).get("cta_source")) ?? sanitizeCtaSource(fallback);
  if (!value) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* stockage bloqué : l'encart reste lu dans l'adresse */
  }
}

/** Encart en cours : celui de l'adresse, sinon celui gardé pour la visite. */
export function currentCtaSource(search: string = typeof window !== "undefined" ? window.location.search : ""): string | null {
  return sanitizeCtaSource(new URLSearchParams(search).get("cta_source")) ?? stored();
}

/** Mur d'inscription d'un outil réservé (/inscription/?next=/tests/) : « mur_tests ». */
export function ctaSourceFromWall(path: string | null | undefined): string | null {
  if (!path) return null;
  const slug = path.replace(/^\/+|\/+$/g, "").replace(/\//g, "-");
  return sanitizeCtaSource(slug ? `mur_${slug}` : null);
}
